// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"w_-z","displaySixCardTiles":"x_-z"};